import { render, staticRenderFns } from "./receptionInfo.vue?vue&type=template&id=5e021934&scoped=true&"
import script from "./receptionInfo.vue?vue&type=script&lang=js&"
export * from "./receptionInfo.vue?vue&type=script&lang=js&"
import style0 from "./receptionInfo.vue?vue&type=style&index=0&id=5e021934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e021934",
  null
  
)

export default component.exports